var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('DyAlert',{ref:"dyAlert",on:{"success":_vm.onSuccess}}),_c('KsAlert',{ref:"ksAlert",on:{"success":_vm.onSuccess}}),_c('SpAlert',{ref:"spAlert",on:{"success":_vm.onSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }